import { useWebSocketQuerySync } from '../../hooks/useWebSocketQuerySync';

/**
 * Component that syncs WebSocket events with React Query cache
 *
 * This component should be placed inside both WebSocketProvider and QueryClientProvider.
 * It automatically invalidates React Query caches when relevant WebSocket events arrive.
 *
 * @example
 * ```tsx
 * <QueryClientProvider client={queryClient}>
 *   <WebSocketProvider>
 *     <WebSocketQuerySync />
 *     <App />
 *   </WebSocketProvider>
 * </QueryClientProvider>
 * ```
 */
export function WebSocketQuerySync() {
  useWebSocketQuerySync();
  return null; // This component doesn't render anything
}

export default WebSocketQuerySync;
